import React, { FunctionComponent, useContext } from "react";
import { Grid, makeStyles, Theme } from "@material-ui/core";
import { BeatLoader } from "react-spinners";
import { NutritionContext } from "../context/nutrition-context";
import { ColorCategoryDictionary } from "../../../models/categories";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    minHeight: 200,
  },
}));

interface IQuestionSectionLoadingIndicatorProps {}

export const QuestionSectionLoadingIndicator: FunctionComponent<IQuestionSectionLoadingIndicatorProps> = (props) => {
  const { activeCategory } = useContext(NutritionContext);
  const classes = useStyles();

  if (!activeCategory) {
    return <></>;
  }

  return (
    <Grid item container justify="center" alignItems="center" xs className={classes.container}>
      <BeatLoader size={18} color={ColorCategoryDictionary[activeCategory].color} />
    </Grid>
  );
};
